import React from 'react';
import { useMediaQuery } from 'react-responsive';

import {
  MEDIA_QUERY_SMALL_SCREEN,
  MEDIA_QUERY_LARGE_SCREEN_1200,
} from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

const PartnerAgentOwnerMarketingPageWhySunroom = () => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const isLargeScreen = useMediaQuery({
    query: MEDIA_QUERY_LARGE_SCREEN_1200,
  });

  return (
    <SrFlex
      boxSizing="border-box"
      width="100%"
      maxWidth="1160px"
      padding="78px 0 0 0"
      margin="0 auto"
      wrap="wrap"
    >
      <SrBox maxWidth="580px" margin={isLargeScreen ? '0 auto' : null}>
        <SrBox marginTop="30px">
          <SrText
            font="greycliff"
            weight="700"
            size={isSmallScreen ? '32' : '40'}
            lineHeight={isSmallScreen ? '38px' : '56px'}
            color="blueGreycliff"
          >
            Why do I use Sunroom to lease my client's properties?
          </SrText>
        </SrBox>
        <SrBox marginTop={isSmallScreen ? '48px' : '64px'}>
          <SrText
            size="24"
            font="greycliff"
            weight="700"
            lineHeight="32px"
            color="blueGreycliff"
            display="block"
          >
            Listed Everywhere
          </SrText>
          <SrBox marginTop="16px" maxWidth="400px">
            <SrText size="16" font="greycliff" weight="600" lineHeight="24px" color="grey500">
              Your property is featured on Zillow, Trulia, the MLS and more.
            </SrText>
          </SrBox>
        </SrBox>
        <SrBox marginTop="48px">
          <SrText
            size="24"
            font="greycliff"
            weight="700"
            lineHeight="32px"
            color="blueGreycliff"
            display="block"
          >
            The Best Renters
          </SrText>
          <SrBox marginTop="16px" maxWidth="400px">
            <SrText size="16" font="greycliff" weight="600" lineHeight="24px" color="grey500">
              Renters go through a comprehensive screening when they apply.
            </SrText>
          </SrBox>
        </SrBox>
        <SrBox marginTop="48px">
          <SrText
            size="24"
            font="greycliff"
            weight="700"
            lineHeight="32px"
            color="blueGreycliff"
            display="block"
          >
            You’ll Lease Faster
          </SrText>
          <SrBox marginTop="16px" maxWidth="400px">
            <SrText size="16" font="greycliff" weight="600" lineHeight="24px" color="grey500">
              With this proven system, you'll reduce the time on market by 26% on average.
            </SrText>
          </SrBox>
        </SrBox>
      </SrBox>
      <img
        src="/images/mobile-app-preview-1.png"
        alt="app preview"
        width={isSmallScreen ? '100%' : '50%'}
        style={{
          display: 'block',
          margin: isLargeScreen ? '0 auto' : null,
          order: isLargeScreen ? '-1' : null,
        }}
      />
    </SrFlex>
  );
};

PartnerAgentOwnerMarketingPageWhySunroom.displayName = 'PartnerAgentOwnerMarketingPageWhySunroom';

export default PartnerAgentOwnerMarketingPageWhySunroom;
